import { Alert } from 'antd';
import React, { Component} from 'react';
// import ReactJson from 'react-json-view'
import ReactJson from '@microlink/react-json-view';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { endpointData } from '../data/endpointdata';

// const parameterEx = [{
//   name: 'lat', description:'Latitude of search area', type: 'number', required: "true", example: 40.68919, default: ''},{
//   name: 'lon', description:'Longitude of search area', type: 'number', required: "true", example: -73.992378, default: ''},{
//   name: 'distance', description:'Search Area radius (in miles)', type: 'number', required: "true", example: 5, default: ''},{
//   name: 'q', description:'Query String using format value or field:value', type: 'string', required: "false", example: 'cuisines:italian', default: ''},{
//   name: 'page', description:'Page Through Results', type: 'number', required: "false", example: '1', default: '1'},{
//   name: 'fullmenu', description:'include full menus (or not)', type: 'Boolean', required: "true", example: 'false', default: 'false'}]

const Authentication = () => {
    const { user } = useAuth();
    // const [loading, setLoading] = useState(false);
    // const [error, setError] = useState('');
    
    return (
        <div className="w-100">
            <div className="row">
                <div className="col">
                    <p>Your API Key is passed as <code>X-API-KEY</code> in header.</p>
                    {!user && (
                        <p>
                            <Link to="/login" className="btn btn-primary">
                                Login to Get API Key
                            </Link>
                        </p>
                    )}
                </div>
            </div>
            <div className="row mt-4">
                <div className="col">
                    <h6>Example Headers:</h6>
                    <div className="code-wrap-1 p-3 bg-custom-dark text-yellow">
                        <pre>
                            <code className="text-light">
                                {JSON.stringify({
                                    Host: "https://menuapi.apix.site",
                                    "x-api-key": "YOUR_API_KEY_GOES_HERE"
                                }, null, 2)}
                            </code>
                        </pre>
                    </div>
                </div>
            </div>
        </div>
    );
};

class Endpoint extends Component {
    constructor(props) {
      super(props);
      // console.log(props.data.parameters)
      if(props.sandbox && props.data.h4Id === 'res-id') {
        props.data.exampleUrl = '/restaurant/7427502926';
        props.data.exampleResponse =  `{
          totalResults: 1,
          page: 1,
          total_pages: 1,
          more_pages: false,
          data: [
          {
          address: {
          streetAddress: "869 S Maple Street",
          city: "Schuppecester",
          state: "NY",
          zip: "52552",
          formatted: "869 S Maple Street Schuppecester, NY 52552"
          },
          geo: {
          lat: 59.618255,
          lon: 3.391893
          },
          restaurantName: "Erdman LLC",
          cuisines: [
          "soup"
          ],
          menus: [ ],
          priceRange: "$",
          priceRangeNum: 1,
          hours: "",
          restaurant_phone: "248.963.2176 x149",
          restaurant_website: "https://creative-igloo.org",
          restaurant_id: "7427502926"
          }
          ],
          numResults: 1
          }`
      }
      this.state = {
        isLoading: true,
        sandbox: props.sandbox,
        params: props.data.parameters,
        title: props.data.title,
        endpoint: props.data.endpoint,
        description: props.data.description,
        method: props.data.method,
        exampleUrl: props.data.exampleUrl,
        h4Id: props.data.h4Id,
        exampleResponse: props.data.exampleResponse
      };

    }
    // constructor

    UNSAFE_componentWillUpdate(newprops) {
     if (newprops.sandbox !== this.state.sandbox) {
      this.setState({ sandbox: newprops.sandbox });
     }
    }

    createTableHead(){
      const {params} = this.state;
      let p = params[0];
      let ths = []
      for (var k in p) {
        ths.push(<th key={k}>{k}</th>);
      }
      return (<tr>{ths}</tr>)
    }
    createParamTable(){
      const {params} = this.state;
      let tbody = []

      for (var i = 0; i < params.length; ++i) {
        let p = params[i];
        // console.log(p)
        let tds = [];
        for (var k in p) {
          if (k === 'example' || k === "name")
          {
            tds.push(<td className={"td-"+ k} key={p[k]+'-'+i}><code>{p[k]}</code></td>);
          }
          else
          {
            tds.push(<td className={"td-"+ k} key={p[k]+'-'+i}>{p[k]}</td>);
          }

        }
        // tds.push(<td key={'name'+i}><strong>{p.name}</strong></td>);
        tbody.push(<tr>{tds}</tr>);
      }

      // console.log(tbody)
      return tbody

    }
    // componentWillUpdate
    componentDidMount(){
        this.setState({ isLoading: false });
        this.createParamTable()
    }
     // componentDidMount


    render() {
        const{
        isLoading,
        title,
        endpoint,
        method,
        description,
        exampleUrl,
        exampleResponse,
        sandbox,
        h4Id
        } = this.state;
        // console.log(sandbox)
        if (isLoading) {
          return <div>Loading...</div>;
        }
        return (
          <div className={"mt-5 w-100 " + (sandbox ? 'sandbox-endpoint' : '')} key={sandbox}>
            <div className="row">
              <div className="col">
                <h4 id={h4Id}><span className="badge badge-success">{method}</span> {title}</h4>
                {sandbox && <Alert message="Sandbox Mode Active" type="info" showIcon />}
                <p>{description}</p>
                <div className="mt-3 mb-3">
                <code className={"d-block w-100 p-3 fira-code-600 fira-code-spaced " + (!sandbox ? 'bg-custom-dark text-white fira-code-700' : 'bg-sandbox-dark text-dark rounded border border-black-50') }><span className={!sandbox ? 'text-api-url fira-code-500 fira-code-spaced' : 'text-gray-50 font-weight-bol'}>{sandbox ? 'https://menuapi.apix.site/sandbox' : 'https://menuapi.apix.site/api'}</span><span className="text-endpoint">{endpoint}</span></code>

                </div>
              </div>
            </div>
            <div className="row mt-4">
             <div className="col">
             <h6>Parameters</h6>
               <table className="table param-table table-bordered">
                 <thead>
                 {this.createTableHead()}
                 </thead>
                 <tbody>
                   {this.createParamTable()}
                 </tbody>
               </table>
             </div>
            </div>
            <div className="row mt-4">
             <div className="col">
             <h6>Example Url</h6>
              <div className="mt-3 mb-3">
                <code className={"d-block w-100 p-3 " + (!sandbox ? 'bg-custom-dark text-white fira-code-700 fira-code-spaced' : 'bg-sandbox text-dark rounded border border-black-50') }><span className="text-white fira-code-400 fira-code-spaced text-api-url">{sandbox ? 'https://menuapi.apix.site/sandbox' : 'https://menuapi.apix.site/api'}</span><span className="fira-code-700 fira-code-spaced text-endpoint">{exampleUrl}</span></code>

                </div>
             </div>
            </div>
            <div className="row mt-4">
             <div className="col">
             <h6>Response</h6>
              <div className="mt-3 mb-3">
                <ReactJson src={exampleResponse} iconStyle="triangle" name="response" style={{padding:20+'px', borderRadius:5+'px'}} collapsed={true} theme="monokai" enableClipboard={false} displayDataTypes={false} />

                </div>
             </div>
            </div>
          </div>

          );
  }
  // /render()
}

class Spacer extends Component {
  render(){
    return <div className="row mt-5 mb-5"><div className="col"><hr/></div></div>
  }
}
class RestaurantGroup extends Component {
    constructor(props) {
      super(props);
      this.state = { isLoading: true, sandbox: props.sandbox };

    }
    // constructor

    UNSAFE_componentWillUpdate(newprops) {

    }

    // componentWillUpdate
    componentDidMount(){
        this.setState({ isLoading: false });
    }
     // componentDidMount


    render() {
        const{
        isLoading,
        sandbox
        } = this.state;
        if (isLoading) {
          return <div>Loading...</div>;
        }
        return (
            <div className="w-100" key={sandbox}>
            <Endpoint data={endpointData.restaurantById} sandbox={sandbox}/>
            <Spacer/>
            <Endpoint data={endpointData.restaurantSearchGeo} sandbox={sandbox}/>
            <Spacer/>
            <Endpoint data={endpointData.restaurantSearchGeoBox} sandbox={sandbox}/>
            <Spacer/>
            <Endpoint data={endpointData.restaurantSearchZip} sandbox={sandbox}/>
            <Spacer/>
            <Endpoint data={endpointData.restaurantSearchState} sandbox={sandbox}/>
            </div>
          );
  }
  // /render()
}
class MenuItemGroup extends Component {
    constructor(props) {
      super(props);
      this.state = { isLoading: true, sandbox: props.sandbox };

    }
    // constructor

    UNSAFE_componentWillUpdate(newprops) {

    }

    // componentWillUpdate
    componentDidMount(){
        this.setState({ isLoading: false });
    }
     // componentDidMount


    render() {
        const{
        isLoading,
        sandbox
        } = this.state;
        if (isLoading) {
          return <div>Loading...</div>;
        }
        return (
            <div className="w-100" key={sandbox}>
            <Endpoint data={endpointData.itemById} sandbox={sandbox}/>
            <Spacer/>
            <Endpoint data={endpointData.itemByRestaurantId} sandbox={sandbox}/>
            <Spacer/>
            <Endpoint data={endpointData.menuitemSearchGeo} sandbox={sandbox}/>
            <Spacer/>
            </div>
          );
  }
  // /render()
}

export {
  Authentication, MenuItemGroup, RestaurantGroup
};
// export Authentication